// @flow
import styled from 'styled-components'
import { Icon } from 'antd'

export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  width: 100vw;
`

export const LoadingIcon = styled(Icon)`
  font-size: 30px;
  padding-top: 30px;
`



// WEBPACK FOOTER //
// ./src/components/layout-loading/style.js